const HisCalculator = ({ color, sx }) => {
  const fillColor = color ?? "#0B4EDB";
  const _sx = sx ?? {};

  return (
    <svg
      style={_sx}
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="30" height="30" fill="white" />
      <path
        d="M8.75 2.5H21.25C21.913 2.5 22.5489 2.76339 23.0178 3.23223C23.4866 3.70107 23.75 4.33696 23.75 5V25C23.75 25.663 23.4866 26.2989 23.0178 26.7678C22.5489 27.2366 21.913 27.5 21.25 27.5H8.75C8.08696 27.5 7.45107 27.2366 6.98223 26.7678C6.51339 26.2989 6.25 25.663 6.25 25V5C6.25 4.33696 6.51339 3.70107 6.98223 3.23223C7.45107 2.76339 8.08696 2.5 8.75 2.5ZM8.75 5V10H21.25V5H8.75ZM8.75 12.5V15H11.25V12.5H8.75ZM13.75 12.5V15H16.25V12.5H13.75ZM18.75 12.5V15H21.25V12.5H18.75ZM8.75 17.5V20H11.25V17.5H8.75ZM13.75 17.5V20H16.25V17.5H13.75ZM18.75 17.5V20H21.25V17.5H18.75ZM8.75 22.5V25H11.25V22.5H8.75ZM13.75 22.5V25H16.25V22.5H13.75ZM18.75 22.5V25H21.25V22.5H18.75Z"
        fill={fillColor}
      />
    </svg>
  );
};

export default HisCalculator;
